/* eslint-disable react/prop-types */
import { makeStyles } from "@material-ui/core";
import { nFormatter } from "lib/utils";
import React from "react";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import { groupBorderColors } from "./utils";

const useStyles = makeStyles(() => ({
  root: { overflow: "auto", width: "100%", maxHeight: "600px" },
  priceChangeContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "5px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontFamily: "inherit",
    maxHeight: "100px",
  },
  tableData: {
    // width: "100%",
    // padding: "12px 16px",
    // alignItems: "center",
    // justifyContent: "flex-end",
  },
  tableDataContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    padding: "12px 16px",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
  },
}));

const arrowUp = (
  <span style={{ color: "#22C55E", fontWeight: "bold", marginRight: 4 }}>
    <FaArrowUp />
  </span>
);

const arrowDown = (
  <span style={{ color: "#EF4444", fontWeight: "bold", marginRight: 4 }}>
    <FaArrowDown />
  </span>
);

const PromotionsProductsTable = ({ promotionsTableData = [] }) => {
  const classes = useStyles();
  // const { products: productSlice } = useSelector((state) => state.catalog);
  // const retailerSlice = useSelector((state) => state.retailers);
  // const configCatSlice = useSelector((state) => state.auth.configCatUser);

  const calculateLift = (currentValue, referenceValue) => {
    return (((currentValue - referenceValue) / referenceValue) * 100).toFixed(
      2
    );
  };

  // const calculateROI = (currentMargin, refMargin, currentInvestmentIn) => {
  //   console.log("refMargin", refMargin);
  //   console.log("currentMargin", currentMargin);
  //   console.log("currentInvestmentIn", currentInvestmentIn);
  //   const calculatedROI =
  //     ((refMargin - currentMargin) / currentInvestmentIn) * 100;
  //   return Number.isNaN(calculatedROI) ? 0 : calculatedROI;
  // };

  const formatData = () => {
    if (promotionsTableData.length === 0) return [];
    return Array.from(promotionsTableData)
      .sort((a, b) => {
        const productLabelA = a.product.label;
        const productLabelB = b.product.label;
        if (productLabelA !== productLabelB) {
          return productLabelA.localeCompare(productLabelB);
        }
        const retailerLabelA = a.retailer.label;
        const retailerLabelB = b.retailer.label;
        return retailerLabelA.localeCompare(retailerLabelB);
      })
      .map((tableData) => {
        return {
          productLabel: tableData.product.label,
          retailerLabel: tableData.retailer.label,
          brandLabel: tableData.brand.label,
          promotionCategoryLabel: tableData.label,
          priceOut: nFormatter(tableData.avg_weight_by_units_price),
          priceOutChange: calculateLift(
            tableData.avg_weight_by_units_price,
            tableData.reference?.avg_weight_by_units_price
          ),
          sellOut: nFormatter(tableData.sum_units),
          sellOutChange: calculateLift(
            tableData.sum_units,
            tableData.reference?.sum_units
          ),
          salesOut: nFormatter(tableData.sum_sales),
          salesOutChange: calculateLift(
            tableData.sum_sales,
            tableData.reference?.sum_sales
          ),
          margin: nFormatter(tableData.sum_margin),
          marginChange: calculateLift(
            tableData.sum_margin,
            tableData.reference?.sum_margin
          ),
          roi: tableData.roi,
        };
      });
  };

  const setKpiColor = (priceChange) => {
    const converted = Number(priceChange);
    if (converted > 0) return "#22C55E";
    if (converted < 0) return "#EF4444";
    return "#000000";
  };

  const setArrowColor = (priceChange) => {
    const converted = Number(priceChange);
    if (converted > 0) return arrowUp;
    if (converted < 0) return arrowDown;
    return null;
  };

  return (
    <div className={classes.root}>
      <table className={classes.table}>
        <thead>
          <tr
            style={{ background: "#181F2B", color: "#fff", textAlign: "left" }}
          >
            <th style={{ padding: "12px 16px" }}>Promotion Category</th>
            <th style={{ padding: "12px 16px" }}>Product</th>
            <th style={{ padding: "12px 16px" }}>Retailer</th>
            <th style={{ padding: "12px 16px" }}>Price Out</th>
            <th style={{ padding: "12px 16px" }}>Sell Out</th>
            <th style={{ padding: "12px 16px" }}>Sales Out</th>
            <th style={{ padding: "12px 16px" }}>Margin</th>
            <th style={{ padding: "12px 16px" }}>ROI</th>
          </tr>
        </thead>
        <tbody>
          {formatData().map((row, idx) => (
            <tr
              key={row.product}
              style={{
                background: idx % 2 === 1 ? "#F6F6F7" : "#fff",
              }}
            >
              <td className={classes.tableData}>
                <div className={classes.tableDataContainer}>
                  <span
                    style={{
                      color: `${groupBorderColors[row.promotionCategoryLabel]}`,
                    }}
                  >
                    {row.promotionCategoryLabel}
                  </span>
                </div>
              </td>
              <td className={classes.tableData}>
                <div className={classes.tableDataContainer}>
                  <span>{row.productLabel}</span>
                </div>
              </td>
              <td className={classes.tableData}>
                <div className={classes.tableDataContainer}>
                  <span>{row.retailerLabel}</span>
                </div>
              </td>
              <td className={classes.tableData}>
                <div className={classes.tableDataContainer}>
                  <span>{row.priceOut}</span>
                  <span
                    className={classes.priceChangeContainer}
                    style={{ color: `${setKpiColor(row.priceOutChange)}` }}
                  >
                    {setArrowColor(row.priceOutChange)}
                    {row.priceOutChange}%
                  </span>
                </div>
              </td>
              <td className={classes.tableData}>
                <div className={classes.tableDataContainer}>
                  <span>{row.sellOut}</span>
                  <span
                    className={classes.priceChangeContainer}
                    style={{ color: `${setKpiColor(row.sellOutChange)}` }}
                  >
                    {setArrowColor(row.sellOutChange)}
                    {row.sellOutChange}%
                  </span>
                </div>
              </td>
              <td className={classes.tableData}>
                <div className={classes.tableDataContainer}>
                  <span>{row.salesOut} </span>
                  <span
                    className={classes.priceChangeContainer}
                    style={{ color: `${setKpiColor(row.salesOutChange)}` }}
                  >
                    {setArrowColor(row.salesOutChange)}
                    {row.salesOutChange}%
                  </span>
                </div>
              </td>
              <td className={classes.tableData}>
                <div className={classes.tableDataContainer}>
                  <span>{row.margin}</span>
                  <span
                    className={classes.priceChangeContainer}
                    style={{ color: `${setKpiColor(row.marginChange)}` }}
                  >
                    {setArrowColor(row.marginChange)}
                    {row.marginChange}%
                  </span>
                </div>
              </td>
              <td className={classes.tableData}>
                <div className={classes.tableDataContainer}>
                  <span
                    className={classes.priceChangeContainer}
                    style={{ color: `${setKpiColor(row.roi)}` }}
                  >
                    {Math.ceil(row.roi * 100) / 100}%
                  </span>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PromotionsProductsTable;
